export const QUOTE_STATUS_DRAFT = 'draft'
export const QUOTE_STATUS_UNDER_REVIEW = 'under_review'
export const QUOTE_STATUS_AWAITING_ORDER = 'awaiting_order'
export const QUOTE_STATUS_ORDERED = 'ordered'
export const QUOTE_STATUS_CANCELLED = 'cancelled'
export const QUOTE_STATUS_DELETED = 'deleted'

export const QUOTE_STATUS_LABELS = {
  [QUOTE_STATUS_DRAFT]: 'Draft',
  [QUOTE_STATUS_UNDER_REVIEW]: 'Under Review',
  [QUOTE_STATUS_AWAITING_ORDER]: 'Approved',
  [QUOTE_STATUS_ORDERED]: 'Ordered',
  [QUOTE_STATUS_CANCELLED]: 'Cancelled',
  [QUOTE_STATUS_DELETED]: 'Deleted',
}

export const SHIPPING_COST = 'shipping_cost'
export const DISCOUNT_AMOUNT = 'discount_amount'
export const EXCLUDED_DATA_KEYS = [SHIPPING_COST, DISCOUNT_AMOUNT]
export const EDITABLE_QUOTE_STATES = [QUOTE_STATUS_DRAFT, QUOTE_STATUS_UNDER_REVIEW, QUOTE_STATUS_AWAITING_ORDER]
export const QUOTE_VALID_UNTIL_DEFAULT_DAYS = 30

export const ACTIVITY_LOG_MESSAGE = 'message'
export const ACTIVITY_LOG_FILE = 'file'
export const ACTIVITY_LOG_EVENT = 'event'

/** Activity log tag names (mirror django/osapi/bom/constants.py). */
export const ACTIVITY_LOG_TAG_STATUS_CHANGED = 'status changed'
export const ACTIVITY_LOG_TAG_VIEWED = 'viewed'
export const ACTIVITY_LOG_TAG_EXPIRING_SOON = 'expiring soon'
export const ACTIVITY_LOG_TAG_EXPIRED = 'expired'

export const TITLE_ONLY_ACTIVITY_LOG_TAGS: ReadonlySet<string> = new Set([
  ACTIVITY_LOG_TAG_STATUS_CHANGED,
  ACTIVITY_LOG_TAG_VIEWED,
  ACTIVITY_LOG_TAG_EXPIRING_SOON,
  ACTIVITY_LOG_TAG_EXPIRED,
])
export const DISCOUNT_TYPE = {
  percentage: 'percentage',
  fixed: 'fixed',
}

export const SUPPLIER_ASSIST_QUOTE_BASE_PATH = '/supplier_assist/quotes'
export const OPEN_CHAT_QUERY = 'openChat'

export const QUOTE_SOURCE_SUPPLIER_ASSIST_PROJECT = 'supplier_assist_project'
export const QUOTE_SOURCE_SUPPLIER_ASSIST_SHOP = 'supplier_assist_shop'

/** Quote retrieve ?source= values that trigger view recording (mirror django/osapi/bom/constants.py). */
export const QUOTE_VIEW_SOURCE_EMAIL = 'email'
export const QUOTE_VIEW_SOURCE_LIST = 'list'
export type QuoteViewSource = typeof QUOTE_VIEW_SOURCE_EMAIL | typeof QUOTE_VIEW_SOURCE_LIST
export const QUOTE_VIEW_SOURCES: ReadonlySet<QuoteViewSource> = new Set([
  QUOTE_VIEW_SOURCE_EMAIL,
  QUOTE_VIEW_SOURCE_LIST,
])

/** Default for new Supplier Assist quote requests (pro can opt out before submit). */
export const DEFAULT_ALLOW_ACCOUNT_MANAGER_ORDER = true
